<template>
  <div class="bg-gray-200 mr-0 overflow-y-auto w-full maincomponent-area">
    <ClientsGrid />
  </div>
</template>

<script>
import ClientsGrid from "./ClientsGrid";

export default {
  name: "clientslist",
  components: { ClientsGrid }
};
</script>
